module.exports = __webpack_public_path__ + "static/media/ladyTeaching.6af108f7.png";